import { AuditExport } from "@/features/oversight/evidence";

export default function AuditExportPage() {
  return <AuditExport />;
}
